<template>
  <div class="block relative z-10 shadow-md group">
    <div class="overflow-hidden rounded-sm animate-pulse group-hover:shadow-lg">
      <div class="relative flex-1 max-w-full bg-gray-300 dark:bg-gray-700">
        <div class="overflow-hidden rounded-sm group-hover:shadow-lg">
          <div
            class="object-cover relative flex-1 w-full max-w-full h-full aspect-portrait" />
        </div>
      </div>
    </div>
  </div>
</template>
